export default "__VITE_ASSET__CUbV29xp__"